export enum NavigationEnum {
    OBJECTS,
    JOBS,
    DELETED_OBJECTS
}
